import { Financials, ICustomerDetails } from './types';

export const INITIAL_CUSTOMER_DETAILS: ICustomerDetails = {
  id: null,
  creditInsuranceId: null,
  creditInsuranceCoverageType: null,
  creditInsuranceCoverageTypeName: null,
  creditInsurancePolicyDate: null,
  negativeCreditAllowance: null,
  absoluteCreditThreshold: null,
  createdDate: null,
  name: null,
  taxId: null,
  emailDomain: null,
  physicalAddress1: null,
  physicalAddress2: null,
  physicalCity: null,
  physicalState: null,
  physicalZip: null,
  physicalCountryCode: null,
  mailingAddress1: null,
  mailingAddress2: null,
  mailingCity: null,
  mailingState: null,
  mailingZip: null,
  mailingCountryCode: null,
  creditLimit: 0,
  insuredFor: 0,
  accountManagerName: null,
  salesManagerName: null,
  invoiceMethod: null,
  billingInstructions: null,
  status: 'Customer',
  subStatus: null,
  paymentTerms: null,
  collectionTerms: null,
  userName: null,
  password: null,
  accountingSysId: null,
  loadInstructions: null,
  bolInstructions: null,
  optOutBalanceEmail: false,
  optOutPastDueDateBalanceEmail: false,
  allowAutoDispatch: false,
  enableLTL: false,
  enableCSP: false,
  ediMapping: null,
  verified: undefined,
  invoicePaperworkRequired: undefined,
  requireEmptyBeforeProcessingLoad: null,
  alwaysTrackLoads: false,
  isPublic: false,
  customerExists: false,
  chargeCreditCardFee: null,
  trackingXId: null,
  accountManagerOfficeId: null,
  salesManagerOfficeId: null,
  accountManagerId: null,
  trackingServiceId: null,
  salesManagerId: null,
  prospectId: null,
  collectionsUserId: null,
  commissionDiscount: null,
  accountingSysBalance: null,
  ediTemplateId: null,
  parentId: null,
  needsPreapproval: undefined,
  outstandingOrders: null,
  orderSummary: null,
  quotes: [],
  comments: [],
  contacts: [],
  requests: [],
  creditApplications: [],
  groups: [],
  financials: {} as Financials,
  collectionComments: [],
  trackings: null,
  metadata: [],
  requiredDocumentTypes: [],
  atgLiability: null,
  agentLiability: null,
  agentLiabilityNote: null,
  agentLiabilityEffectiveDate: null,
  claimedBy: null,
  claimedById: null,
  pcMilerVersion: null,
  collectionTierId: null,
  nextActionDate: null,
  keyReasonId: null,
  insurance: null,
  ltlCostPlus: null,
  businessTypeName: null,
  businessTypeCode: null,
  businessTypeId: null,
  businessTypeDisplayName: null,
  loadPending: false,
  paymentType: 0,
  requestedCustomerDoNotSolicit: null,
  isApprovedCustomerDoNotSolicit: null,
  isCustomerCentralized: null,
  seasonality: null,
  approvedCustomerDoNotSolicitDate: null,
  holdRetraction: false,
  revisitRetractionDate: null,
  exceptionReason: null,
  seasonalityComment: '',
  trackingVisibilityProvider: null,
  capacityGroupId: null,
  defaultLogoUrl: null,
  pendingCreditRequests: [],
  ediRequest: null,
  outstandingBalance: 0,
  fuelReimbursement: {
    fuelReimbursementEnabled: false,
    integrationKey: null,
  },
  accountManagerEmail: null,
  accountManagerPhone: null,
  accountManagerOfficeName: null,
  accountManagerOfficeAccountingGroupName: null,
  salesManagerEmail: null,
  salesManagerPhone: null,
  salesManagerOfficeName: null,
  salesManagerOfficeAccountingGroupName: null,
  customerTier: null,
  isPublicEditable: false,
  mcNumber: null,
  isAuthorityFreightBroker: null,
  isAuthorityCarrier: null,
  isAuthorityFreightForwarder: null,
  isAuthorityDirectShipper: null,
  assetBased: null,
  isCrossBorder: null,
  pointOfSaleInstructions: null,
  tmsPortalViewModel: undefined,
};
